import { thunk } from "redux-thunk";
import { applyMiddleware, compose, createStore } from "redux";

import rootReducer from "./rootReducer";
import { loadState, saveState, Items } from "./storePersist";

const middlewares = [thunk];

const store = createStore(
  rootReducer,
  { user: { ...loadState(Items.APP_USER), isLoggedIn: false } },
  compose(
    applyMiddleware(...middlewares),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

store.subscribe(() => saveState(store.getState().user, Items.APP_USER));

export default store;
